import {useEffect, useState} from 'react';

import {useFormStore} from '../../../Stores/form';

import Phone from '../Messenger/Phone';

import './index.scss';


export default function PhoneField(props) {
    const {content, disabled, field, hideErrors, isEditMode, onChange, onFocus, onBlur} = props;
    const [isDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [pseudoInputClass, setPseudoInputClass] = useState('pseudoInput');

    useEffect(() => {
        if (showErrorText) {
            setPseudoInputClass('pseudoInput error')
        }
        else {
            setPseudoInputClass('pseudoInput')
        }
    }, [showErrorText])

    const onPhoneBlur = (value) => {
        if (onBlur) onBlur({target: {value}});
    }

    const onPhoneChange = (value) => {
        onChange({target: {value}});
    }

    return <div className="PhoneField">
        <div className={pseudoInputClass}>
            {field?.placeholder && <div className='inputLabel'>{field?.placeholder}</div>}
            <Phone
                field={field}
                value={content[field.id] || ''}
                isDisabled={isDisabled}
                onChange={onPhoneChange}
                onBlur={onPhoneBlur}
            />

            {field?.notes && <div className="fieldNotes">
                {field?.notes && <p>{field.notes}</p>}
            </div>}
        </div>
    </div>
}
